import PropTypes from 'prop-types';
import React from 'react';
import {
  FormGroup,
  InputGroup,
  Button,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton } from 'react-bootstrap-table';
import moment from 'moment';
import { monthNameFormatDate } from '../../../core/date';


const roomNameFormatter = (cell, row) => {
  switch (cell) {
    case 1:
      return 'Suite'
    case 2:
      return 'King'
    case 3:
      return 'Double'
    case 4:
      return 'Two Beds'
    case 5:
      return 'Junior Suite'
    case 6:
      return '2 Bedroom Suite'
  }
}

const displayDate = (cell, row) => {
  return monthNameFormatDate(cell);
}

const numberOfDayFormatter = (cell, row) => {
  const a = moment(row.check_out_date);
  const b = moment(row.check_in_date);
  return a.diff(b, 'days')
}

const formatMoney = (value, currency) => {
  if (!value) return value;
  // const onlyNums = value.replace(/[^\d]/g, '');
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits: 2,
    currency,
  });
  return formatter.format(value);
};

class BidDetailTable extends React.Component {
  render() {
    const { bid, bidData } = this.props;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 2,
    });

    const taxFormatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 3,
    });
    const currency = this.props.bid.hotel.currency;
    const commissionRate = formatter.format(this.props.bid.commission_rate);
    const taxRate = taxFormatter.format(this.props.bid.hotel.tax_rate);
    const additionalTax = this.props.bid.hotel.additional_tax;
    const resortFee = this.props.bid.resort_fee;
    return (
      <div
        className="row"
        style={{
          paddingTop: '20px',
          paddingBottom: '20px',
        }}
      >
        <div className="col-md-12">
          {/* {this.props.canEdit && ( */}
            <Button onClick={this.props.handleEdit}>Edit</Button>
          {/* )} */}
          <p>
            Currency: {currency}
            <br />
            Tax Rate: {taxRate}
          </p>

          <BootstrapTable
            data={bidData}
            striped
          >
            <TableHeaderColumn dataField="room_type" width="100" isKey headerAlign="center" dataAlign="center" dataFormat={roomNameFormatter}>Room Type</TableHeaderColumn>
            <TableHeaderColumn dataField="room_category" width="100" headerAlign="center" dataAlign="center">Room Category</TableHeaderColumn>
            <TableHeaderColumn dataField="no_of_Guest" width="100" headerAlign="center" dataAlign="center">No of Rooms</TableHeaderColumn>
            <TableHeaderColumn dataField="check_in_date" width="100" headerAlign="center" dataAlign="center" dataFormat={displayDate}>Check in Date</TableHeaderColumn>
            <TableHeaderColumn dataField="check_out_date" width="100" headerAlign="center" dataAlign="center" dataFormat={displayDate}>Check out Date</TableHeaderColumn>
            <TableHeaderColumn width="100" headerAlign="center" dataAlign="center" editable={false} dataFormat={numberOfDayFormatter}>No of Days</TableHeaderColumn>
            <TableHeaderColumn dataField="rate_per_night" width="100" headerAlign="center" dataFormat={(cell) => formatMoney(cell, currency)} editable={false} dataAlign="center">Rate Per Night</TableHeaderColumn>
          </BootstrapTable>
          <p>Commission: {commissionRate}</p>
          <p>Additional Tax (per day): {currency}&nbsp;{additionalTax}</p>
          <p>Resort Fee (per day): {currency}&nbsp;{resortFee}</p>
          <p>Total : {currency}&nbsp;{this.props.total}</p>
          <h4><b>Questions Answers Details:</b></h4>
          <ol type='1'>
          {this.props.addedanswers.map((value) =>(
            <div>
            {value.answer?(
              <li>
                <h5><b>{value.question}</b></h5>
                <h5>{value.answer}</h5><hr style={{ margin:'0px',backgroundColor:'black' }} />
              </li>
              ):('')}
              </div>
            ))}
          </ol>

        </div>
      </div>
    );
  }
}


BidDetailTable.propTypes = {
  bid: PropTypes.object.isRequired,
  canEdit: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func.isRequired,
};

export default BidDetailTable;



// WEBPACK FOOTER //
// src/routes/booking/components/BidDetailTable.js